<template>
  <div class="bn-wrap">
    <div v-if="!headBanner" class="bn-container">
      <div class="bn-bd">
        <h2 v-if="title" v-html="title" />
      </div>
    </div>
    <img v-if="headBanner" :src="headBanner" :alt="title">
    <div v-if="insuranceLabelPosition === 'legacy'" class="default-infor">
      <div v-if="insuranceInfor.companyName" class="company-name after-bdr">
        {{ insuranceInfor.companyName }}
      </div>
      <div v-if="insuranceInfor.name" class="insurance-name">
        {{ insuranceInfor.name }}
      </div>
    </div>
    <a
      v-if="insuranceInfor.companyIntroductionUrl"
      class="company-itr"
      :href="insuranceInfor.companyIntroductionUrl"
    >
      {{ insuranceInfor.companyName || '公司介绍' }}
    </a>
    <header v-if="insuranceLabelPosition === 'bottom'" class="insurance-name">
      {{ insuranceInfor.name }}
    </header>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    headBanner: {
      type: String,
      default: '',
    },
    insuranceInfor: {
      type: Object,
      default() {
        return {}
      },
    },
    insuranceLabelPosition: {
      type: String,
      default: 'none',
      validator: val => ['none', 'legacy', 'bottom'].includes(val)
    }
  },
}
</script>

<style lang="postcss" scoped>
.bn-wrap {
  overflow: hidden;
  position: relative;
  width: 100%;
  .bn-container {
    overflow: hidden;
    height: 115px;
  }
  img {
    width: 100%;
    vertical-align: middle;
  }
  .default-infor {
    padding-left: 18px;
    padding-right: 145px;
    & .company-name {
      font-size: 15px;
      padding: 3px 6px;
      margin-bottom: 9px;
    }
    & .insurance-name {
      font-size: 17px;
      font-weight: bold;
      line-height: 1.5;
    }
  }
  .bn-bd {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 115px;
    padding-top: 8px;
    text-align: center;
    color: #fff;
    h2 {
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      width: 90%;
      max-height: 88px;
      transform: translate(-50%, -50%);
      margin-top: -11px;
      font-size: 24px;
    }
  }
}
</style>
<style lang="postcss">
.theme-banner {
  & .insurance-name {
    position: absolute;
    font-size: 17px;
    font-weight: bold;
    color: #fff;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 16.56%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
